export const VIEW_TYPES = {
  phoneNumberEntry: 'phoneNumberEntry',
  verificationCodeEntry: 'verificationCodeEntry',
};

export const SUBSCRIPTION_GROUPS = {
  messageType: 'messageType',
};

export const SUBSCRIPTION_GROUP_IDS = {
  smsMarketing: 'sms-marketing',
  smsTransactional: 'sms-transactional',
};
